import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import { Icons } from '../../../utilities';
import MaterialDetails from './MaterialDetails/MaterialDetails';
import FinishingDetails from './FinishingDetails/FinishingDetails';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './Material.scss';
import { string } from '../../../localization';
import { checkIfCanvasApp } from '../../../redux/homeActions';

const Material = props => {
  const { materials, dispatchers } = props;

  const materialOptions = [];

  if (materials.length > 1) {
    materialOptions.push({
      name: string.MATERIAL_STRING_KEY,
      alt_text: 'Material-icon',
      tab_id: 'material',
      img_url: Icons.materialDefault,
      slected_img_url: Icons.materialHover
    });
  }

  if (dispatchers.checkIfCanvasApp()) {
    materialOptions.push({
      name: string.FINISHING_KEY,
      alt_text: 'Finishing-icon',
      tab_id: 'finishing',
      img_url: Icons.finishingIconDefault,
      slected_img_url: Icons.finishingIconHover
    });
  }

  let activeTabId = null;
  if (materialOptions.length > 0) {
    activeTabId = materialOptions[0].tab_id;
  }
  const [activeTab, setActiveTab] = useState(activeTabId);
  const [hoverTabId, setHoverTabId] = useState(' ');

  return (
    <div className='text-center' id='material'>
      <Nav pills horizontal='true' className='text-white'>
        {materialOptions.map(option => (
          <NavItem key={option.alt_text}>
            <NavLink
              className={classnames({ active: activeTab === option.tab_id })}
              onClick={() => {
                setActiveTab(option.tab_id);
              }}
              onMouseOver={() => {
                setHoverTabId(option.tab_id);
              }}
              onFocus={() => {}}
              onMouseOut={() => {
                setHoverTabId(' ');
              }}
              onBlur={() => {}}
            >
              <div className=' d-flex '>
                <div className='icon-wrapper-horizontal '>
                  <img
                    alt={option.alt_text}
                    className='center-align-icon'
                    src={
                      activeTab === option.tab_id ||
                      hoverTabId === option.tab_id
                        ? option.slected_img_url
                        : option.img_url
                    }
                  />
                </div>
              </div>
              <div className='tab-lable-container'>{option.name}</div>
            </NavLink>
          </NavItem>
        ))}
      </Nav>

      <TabContent activeTab={activeTab}>
        <TabPane tabId='material'>
          <MaterialDetails />
        </TabPane>
        <TabPane tabId='finishing'>
          <FinishingDetails />
        </TabPane>
      </TabContent>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    activeTab: state.sideBar.activeMaterialTab,
    materials: state.modal.storeData.materials
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: bindActionCreators({ checkIfCanvasApp }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Material);
